"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7299],{

/***/ 93568:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "v": function() { return /* binding */ ccpa; }
});

;// CONCATENATED MODULE: ./src/landingPage/datasets/usStatesList.js
var usStatesList = [
    {
        name: "Alabama",
        abbreviation: "AL"
    },
    {
        name: "Alaska",
        abbreviation: "AK"
    },
    {
        name: "American Samoa",
        abbreviation: "AS"
    },
    {
        name: "Arizona",
        abbreviation: "AZ"
    },
    {
        name: "Arkansas",
        abbreviation: "AR"
    },
    {
        name: "California",
        abbreviation: "CA"
    },
    {
        name: "Colorado",
        abbreviation: "CO"
    },
    {
        name: "Connecticut",
        abbreviation: "CT"
    },
    {
        name: "Delaware",
        abbreviation: "DE"
    },
    {
        name: "District Of Columbia",
        abbreviation: "DC"
    },
    {
        name: "Federated States Of Micronesia",
        abbreviation: "FM"
    },
    {
        name: "Florida",
        abbreviation: "FL"
    },
    {
        name: "Georgia",
        abbreviation: "GA"
    },
    {
        name: "Guam",
        abbreviation: "GU"
    },
    {
        name: "Hawaii",
        abbreviation: "HI"
    },
    {
        name: "Idaho",
        abbreviation: "ID"
    },
    {
        name: "Illinois",
        abbreviation: "IL"
    },
    {
        name: "Indiana",
        abbreviation: "IN"
    },
    {
        name: "Iowa",
        abbreviation: "IA"
    },
    {
        name: "Kansas",
        abbreviation: "KS"
    },
    {
        name: "Kentucky",
        abbreviation: "KY"
    },
    {
        name: "Louisiana",
        abbreviation: "LA"
    },
    {
        name: "Maine",
        abbreviation: "ME"
    },
    {
        name: "Marshall Islands",
        abbreviation: "MH"
    },
    {
        name: "Maryland",
        abbreviation: "MD"
    },
    {
        name: "Massachusetts",
        abbreviation: "MA"
    },
    {
        name: "Michigan",
        abbreviation: "MI"
    },
    {
        name: "Minnesota",
        abbreviation: "MN"
    },
    {
        name: "Mississippi",
        abbreviation: "MS"
    },
    {
        name: "Missouri",
        abbreviation: "MO"
    },
    {
        name: "Montana",
        abbreviation: "MT"
    },
    {
        name: "Nebraska",
        abbreviation: "NE"
    },
    {
        name: "Nevada",
        abbreviation: "NV"
    },
    {
        name: "New Hampshire",
        abbreviation: "NH"
    },
    {
        name: "New Jersey",
        abbreviation: "NJ"
    },
    {
        name: "New Mexico",
        abbreviation: "NM"
    },
    {
        name: "New York",
        abbreviation: "NY"
    },
    {
        name: "North Carolina",
        abbreviation: "NC"
    },
    {
        name: "North Dakota",
        abbreviation: "ND"
    },
    {
        name: "Northern Mariana Islands",
        abbreviation: "MP"
    },
    {
        name: "Ohio",
        abbreviation: "OH"
    },
    {
        name: "Oklahoma",
        abbreviation: "OK"
    },
    {
        name: "Oregon",
        abbreviation: "OR"
    },
    {
        name: "Palau",
        abbreviation: "PW"
    },
    {
        name: "Pennsylvania",
        abbreviation: "PA"
    },
    {
        name: "Puerto Rico",
        abbreviation: "PR"
    },
    {
        name: "Rhode Island",
        abbreviation: "RI"
    },
    {
        name: "South Carolina",
        abbreviation: "SC"
    },
    {
        name: "South Dakota",
        abbreviation: "SD"
    },
    {
        name: "Tennessee",
        abbreviation: "TN"
    },
    {
        name: "Texas",
        abbreviation: "TX"
    },
    {
        name: "Utah",
        abbreviation: "UT"
    },
    {
        name: "Vermont",
        abbreviation: "VT"
    },
    {
        name: "Virgin Islands",
        abbreviation: "VI"
    },
    {
        name: "Virginia",
        abbreviation: "VA"
    },
    {
        name: "Washington",
        abbreviation: "WA"
    },
    {
        name: "West Virginia",
        abbreviation: "WV"
    },
    {
        name: "Wisconsin",
        abbreviation: "WI"
    },
    {
        name: "Wyoming",
        abbreviation: "WY"
    }, 
];

;// CONCATENATED MODULE: ./src/landingPage/datasets/forms/ccpa.js

var ccpa = {
    title: "Personal Information Request Form for California Residents",
    header_1: 'To exercise your rights under the California Consumer Protection Act ("CCPA"), please submit a verifiable consumer request to us by filling out the following form or emailing us with the information requested in the form below at ',
    link: "privacy@demystdata.com",
    link_target: "privacy@demystdata.com",
    header_2: ". Please note, only you, or a person who you authorize to act on your behalf, may make a verifiable consumer request related to your personal information.",
    paragraph_1: "Demyst Data will not discriminate against you for exercising any of your CCPA rights.",
    paragraph_2: 'You may also opt out of the sharing or "sale" of your Personal Information by selecting the "Opt out of the sale of my Personal Information" option below consistent with applicable law. Please note, California’s definition of "sale" includes transfers that ordinarily may not be thought of as a "sale" in the traditional sense – such as sharing information with our affiliates.',
    fields: [
        {
            label: "Select one or more of the following:",
            id: "categories",
            component: "multiplechoice",
            options: [
                "Deletion of my Personal Information",
                "Opt out of the sale of my Personal Information",
                "Access to a port or copy of my Personal Information", 
            ],
            required: true
        },
        {
            label: "Full name",
            id: "full_name",
            type: "text",
            component: "input",
            required: true
        },
        {
            label: "Email address",
            id: "email",
            type: "email",
            component: "input",
            required: true
        },
        {
            label: "Street",
            id: "address",
            type: "text",
            component: "input",
            required: true
        },
        {
            label: "City",
            id: "city",
            type: "text",
            component: "input",
            required: true
        },
        {
            label: "Postal code",
            id: "postal_code",
            type: "text",
            component: "input",
            required: true
        },
        {
            label: "State",
            id: "state",
            type: "select",
            component: "select",
            placeholder: "Select a state",
            options: usStatesList,
            required: true
        },
        {
            label: "",
            id: "residency",
            component: "singlechoice",
            options: [
                "A California resident exercising the rights afforded to me under the CPA, or",
                "The agent of a California resident, who has authorized the requires on their behalf, and that I have verified their identity, obtained a valid certification from the California Secretary of State and have complied with all applicable laws and regulations.", 
            ],
            required: false
        }, 
    ],
    form: {
        label: "ALL FIELDS ARE REQUIRED",
        title: "Personal Information Request Form",
        residency: {
            header: "By submitting this request, I verify under perjury that the Information I am requesting and submitting is true and correct and that I am:",
            footer: "I understand that my request will not be performed until my identity (or the identity and authority of anyone who may attempt to act my behalf) is verified in accordance with applicable law."
        },
        button_text: "Submit"
    },
    errors: {
        field_required: "This field is required!",
        incorrect_mail: "This email address is incorrect."
    }
};


/***/ }),

/***/ 85666:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ meta; }
/* harmony export */ });
var meta = {
    homepage: {
        title: "Demyst: The External Data Management Platform",
        description: "Demyst enables data teams to manage all their external data. External data orchestration at scale, with pipelines that provide trusted external data."
    },
    platform: {
        title: "The Demyst Platform",
        description: "Use Demyst to build your External Data Hub. Demyst provides the end-to-end platform you need to onboard and ingest the right external data into your Data Hub, with our experts working closely with you every step of the way."
    },
    platform_discover: {
        title: "Data Discovery",
        description: "Access hundreds of fully integrated sources, or easily request something new with the Demyst Platform."
    },
    platform_management: {
        title: "Maintenance & Support",
        description: "Simplify the management of all your external data with a single global interface to reduce maintenance burden and maximize value."
    },
    platform_governance: {
        title: "Governance, Procurement & Compliance",
        description: "Say goodbye to the “Compliance Versus Speed” trade-off. Meet industry leading compliance practices whilst typically onboarding new data in four weeks or less."
    },
    platform_deployment: {
        title: "Deployment",
        description: "Deploy up to ten times the data, ten times faster with the Demyst Platform."
    },
    whydataops: {
        title: "Frictionless External Data",
        description: "Keeping pace with the expanding universe of external data is painful without the right technology supporting you."
    },
    ccpa: {
        title: "CCPA",
        description: "Personal Information Request Form for California Residents"
    },
    dsar: {
        title: "DSAR",
        description: "Data Subject Action Request"
    },
    case_study: {
        title: "Resources",
        description: "Meet the industry leaders across the globe that are unlocking the power of external data with Demyst."
    },
    about: {
        title: "About us",
        description: "Demyst believes that external data is the next frontier of business impact, able to power competitive advantages in industries around the world with improved decisioning, new products and better efficiencies."
    },
    contact: {
        title: "Contact us",
        description: "Contact us with the form below to learn how Demyst helps you discover, access, license, and deploy data using our end-to-end EDaaS (External Data as a Service) offering, or if you have any other general inquiries."
    },
    request: {
        title: "Schedule a Demo",
        description: "Schedule a Demo with the form below to learn how the Demyst platform empowers users to discover, access, license, and deploy external data."
    },
    careers: {
        title: "Careers",
        description: "Join our team to immerse yourself in an ecosystem of strategic business challenges and opportunities and awe-inspiring data access."
    },
    report: {
        title: "Free Discovery Report",
        description: "Our free data discovery report gives you a summary of the specific data sources, attributes, analytics, and integration models you can use to solve your business challenges."
    },
    privacy: {
        title: "Privacy Policy",
        description: "This Privacy Policy describes what information we collect when you use our Software, how we use that information, and what choices we offer you to access, update, and control it."
    },
    accessibility: {
        title: "Accessibility Policy",
        description: "This Accessibility Policy outlines the measures we have put in place to ensure that our service is inclusive and usable by as many people as possible"
    },
    terms: {
        title: "Terms and Conditions",
        description: "Demyst Data Limited and its affiliated companies (together, “Demyst Data” or “we” and sometimes “us”) provide the websites www.demystdev.wpengine.com and demystdata.com (collectively, the “Website”) and the Demyst Data software and libraries (collectively referred to herein as the/our “Software” or the/our “Services”), subject to your agreement to and compliance with these Terms and Conditions (the “Terms”)."
    },
    cookies: {
        title: "Cookies Policy",
        description: "This policy explains the different cookies used by Demyst Data on our corporate website and on our Platform (collectively, “Site”) and how you can control them. We may change this Cookie Policy at any time. Please look at the “Last Updated” date at the top of this page to see when this Cookie Policy was last revised. Any changes in this Cookie Policy will become effective when we make the revised Cookie Policy available on or through the  Site. Please see our Privacy Notice to understand the other ways we use the personal information we collect about you."
    },
    subprocessor: {
        title: "Sub-processor Policy",
        description: "Demyst uses certain Sub-contractors (Processors where we act in a “Data Controller” capacity or Sub-processors where we act in a“Data Processor” capacity) to assist it in providing Demyst’s services, including the processing of personal data."
    },
    business: {
        title: "Business Data",
        description: "Harness hundreds of operationalized data sources and marketplaces, through a single API."
    },
    demystvs: {
        title: "Demyst vs. Data Consulting",
        description: "Demyst has a purpose built platform to connect you to the data you need and deliver it quickly into production."
    },
    adxfincrime: {
        title: "Demyst DataOps for FinCrime",
        description: "Demyst has a purpose built platform to connect you to the data you need and deliver it quickly into production."
    },
    adxpartnership: {
        title: "Demyst and AWS Data Exchange",
        description: "Demyst has a purpose built platform to connect you to the data you need and deliver it quickly into production."
    },
    adxexchange: {
        title: "Demyst and AWS Data Exchange",
        description: "Demyst and the Amazon Web Services (AWS) Data Exchange help customers get data into production to achieve data-driven business outcomes faster."
    },
    industries: {
        financialservices: {
            title: "Financial Services Industry",
            description: "Rapidly deploy the right external data solutions for financial services. Optimize your external data spend with a single platform."
        },
        insurance: {
            title: "Insurance Industry",
            description: "Rapidly deploy the right external data solutions for insurance."
        }
    },
    enterprise: {
        title: "Enterprise",
        description: "Delivering End-To-End Value Across The Enterprise."
    },
    newsletter: {
        title: "Newsletter",
        description: "A weekly summary of Demyst product activities and general news impacting the market for external data."
    },
    pricing: {
        title: "Pricing",
        description: "Flexible Options, Transparent Pricing. Select the right plan for your business."
    },
    partners: {
        title: "Partners",
        description: "Flexible Options, Transparent Pricing. Select the right plan for your business."
    },
    usecases: {
        bnpl: {
            title: "Automate Buy Now, Pay Later",
            description: "Access ready-to-deploy data APIs for KYC, Fraud, Compliance and Credit Decisioning , aggregating global data from multiple data partners into a single, configurable data feed."
        },
        kyc: {
            title: "KYC Workflow Automation",
            description: "A single platform for seamless onboarding and verification of customers globally."
        },
        kyb: {
            title: "KYB Workflow Automation",
            description: "A single platform for seamless onboarding and verification of businesses globally."
        },
        applicationprefill: {
            title: "Application Prefill Optimization",
            description: "A single platform for prefilling data pertaining to people, places, and businesses, globally."
        },
        dataenrichment: {
            title: "Enrich Leads",
            description: "A single platform to identify new leads (person, place, business) globally."
        },
        leadtargeting: {
            title: "Optimize Lead Targeting",
            description: "A single platform to identify new leads, enrich leads, and priortiize leads across people, places, and businesses, globally."
        },
        portfoliomonitoring: {
            title: "Optimize Portfolio Monitoring",
            description: "A single platform to enrich customer profiles for retention and cross-sell intiatives"
        },
        businessdecisioning: {
            title: "Business Customer Onboarding",
            description: "Build an initial business customer profile to enable improved new business onboarding decisions and minimize risk exposure."
        },
        creditbureau: {
            title: "Optimize Credit Decisioning",
            description: "A single platform to integrate and manage credit bureau feeds globally."
        }
    }
};


/***/ }),

/***/ 75562:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "a": function() { return /* binding */ DataFormTemplate; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/landingPage/views/components/Button.jsx
var Button = __webpack_require__(88749);
// EXTERNAL MODULE: ./src/landingPage/views/components/form/InfoBox.jsx + 3 modules
var InfoBox = __webpack_require__(40782);
// EXTERNAL MODULE: ./src/landingPage/datasets/forms/ccpa.js + 1 modules
var ccpa = __webpack_require__(93568);
// EXTERNAL MODULE: ./src/landingPage/views/Forms/templates/components/StandardField.jsx + 7 modules
var StandardField = __webpack_require__(24606);
;// CONCATENATED MODULE: ./src/landingPage/views/Forms/templates/components/CCPAForm.jsx




var CCPAForm = function(param) {
    var data = param.data, formData = param.formData, changeData = param.changeData, errors = param.errors;
    var inertRef = (0,react.useRef)(null);
    (0,react.useEffect)(function() {
        if (inertRef.current) inertRef.current.setAttribute("inert", "");
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "ccpa-label",
                children: ccpa/* ccpa.form.label */.v.form.label
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StandardField/* StandardField */.y, {
                fields: data.fields.slice(0, 3),
                formData: formData,
                changeData: changeData,
                errors: errors
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: "ccpa-inputs_section",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StandardField/* StandardField */.y, {
                    fields: data.fields.slice(3, 7),
                    formData: formData,
                    changeData: changeData,
                    errors: errors
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                        id: "standard-org_contact_ref"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                        ref: inertRef,
                        className: "input-main contact-field-secondary",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                className: "input-label",
                                htmlFor: "Company Name",
                                children: [
                                    "Company Name",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {})
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                id: "Company Name",
                                name: "Company Name",
                                className: "input-proper",
                                type: "email",
                                tabIndex: -1,
                                autoComplete: "off",
                                value: formData.org_contact_ref || "",
                                onChange: function(e) {
                                    return changeData(e.target.value, {
                                        id: "org_contact_ref"
                                    });
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "input-error"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "ccpa-paragraph_small",
                children: ccpa/* ccpa.form.residency.header */.v.form.residency.header
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                id: "residency"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StandardField/* StandardField */.y, {
                fields: data.fields.slice(7, 8),
                formData: formData,
                changeData: changeData,
                errors: errors
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "ccpa-paragraph_small last",
                children: ccpa/* ccpa.form.residency.footer */.v.form.residency.footer
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/landingPage/views/components/form/Textarea.jsx
var Textarea = __webpack_require__(55746);
// EXTERNAL MODULE: ./node_modules/react-icons/fi/index.mjs
var fi = __webpack_require__(2777);
;// CONCATENATED MODULE: ./src/landingPage/views/Forms/templates/components/RetractableField.jsx



var RetractableField = function(param) {
    var fields = param.fields, formData = param.formData, changeData = param.changeData, errors = param.errors;
    return fields.map(function(field, fieldIndex) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                    id: "retractible-".concat(field.id)
                }),
                formData[field.controller] === true && field.component === "retractabletextarea" && /*#__PURE__*/ (0,jsx_runtime.jsx)(Textarea/* Textarea */.g, {
                    value: formData[field.id],
                    label: field.label,
                    onChange: function(e) {
                        return changeData(e, field);
                    },
                    error: errors[field.id],
                    required: field.required
                }),
                field.component === "retractable" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                    className: "retractable-checkbox",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                            id: field.id
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                            className: "retractable-checkbox-label",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "retractable-checkbox-label-icon",
                                    children: formData[field.id] === false ? /*#__PURE__*/ (0,jsx_runtime.jsx)(fi/* FiPlus */.OvN, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(fi/* FiMinus */.ego, {})
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "retractable-checkbox-label-name",
                                    children: field.label
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                    type: "checkbox",
                                    value: formData[field.id],
                                    checked: formData[field.id],
                                    onChange: function() {
                                        return changeData(!formData[field.id], field);
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "retractable-checkbox-box"
                                })
                            ]
                        })
                    ]
                })
            ]
        }, fieldIndex);
    });
};

;// CONCATENATED MODULE: ./src/landingPage/views/Forms/templates/components/DSARForm.jsx



var DSARForm = function(param) {
    var data = param.data, formData = param.formData, changeData = param.changeData, errors = param.errors;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "dsar-header",
                children: data.form.title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StandardField/* StandardField */.y, {
                fields: data.fields.slice(0, 6),
                formData: formData,
                changeData: changeData,
                errors: errors
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(RetractableField, {
                fields: data.fields.slice(6, 8),
                formData: formData,
                changeData: changeData,
                errors: errors
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "dsar-label",
                children: data.form.data_subject.title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StandardField/* StandardField */.y, {
                fields: data.fields.slice(8, 9),
                formData: formData,
                changeData: changeData,
                errors: errors
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                className: "dsar-form_indent",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "dsar-form_paragraph",
                        children: data.form.data_subject.ensurance
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "dsar-form_paragraph",
                        children: data.form.data_subject.nature
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "dsar-form_paragraph",
                        children: data.form.data_subject.identification
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StandardField/* StandardField */.y, {
                fields: data.fields.slice(9, 10),
                formData: formData,
                changeData: changeData,
                errors: errors
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: "dsar-form_indent",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "dsar-form_paragraph",
                    children: data.form.data_subject.decline
                })
            }),
            formData["is_data_subject"] === data.fields.filter(function(field) {
                return field.id === "is_data_subject";
            })[0].options[1] && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "dsar-label",
                        children: data.form.detail_data_subject.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StandardField/* StandardField */.y, {
                        fields: data.fields.slice(10, 17),
                        formData: formData,
                        changeData: changeData,
                        errors: errors
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "dsar-label",
                children: data.form.rights.title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "dsar-form_paragraph",
                children: data.form.rights.identify
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "dsar-form_paragraph",
                children: data.form.rights.details
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(RetractableField, {
                fields: data.fields.slice(17, 31),
                formData: formData,
                changeData: changeData,
                errors: errors
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                className: "dsar-form_indent",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "dsar-form_paragraph",
                        children: data.form.rights.note
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "dsar-form_paragraph",
                        children: data.form.rights.other_types
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "dsar-form_paragraph",
                        children: data.form.rights.circumstances
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "dsar-label",
                children: data.form.previous.title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "dsar-form_paragraph",
                children: data.form.previous.note
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StandardField/* StandardField */.y, {
                fields: data.fields.slice(31, 34),
                formData: formData,
                changeData: changeData,
                errors: errors
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "dsar-label",
                children: data.form.declaration.title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "dsar-form_paragraph",
                children: data.form.declaration.declaration
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StandardField/* StandardField */.y, {
                fields: data.fields.slice(34, 36),
                formData: formData,
                changeData: changeData,
                errors: errors
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/landingPage/utils/form-functions.js
var form_functions = __webpack_require__(67534);
// EXTERNAL MODULE: ./src/config/userTracking.js
var userTracking = __webpack_require__(67474);
// EXTERNAL MODULE: ./src/api/userApi.js
var userApi = __webpack_require__(62725);
// EXTERNAL MODULE: ./node_modules/react-google-recaptcha/lib/esm/index.js + 3 modules
var esm = __webpack_require__(34853);
// EXTERNAL MODULE: ./src/config/appConfig.js
var appConfig = __webpack_require__(84762);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/framer-motion.es.js
var framer_motion_es = __webpack_require__(6805);
// EXTERNAL MODULE: ./src/utils/serializeError.js
var serializeError = __webpack_require__(99584);
// EXTERNAL MODULE: ./src/platform/components/MessageBox/MessageBox.jsx
var MessageBox = __webpack_require__(43454);
;// CONCATENATED MODULE: ./src/landingPage/views/Forms/templates/DataFormTemplate.jsx


















var DataFormTemplate = function(param) {
    var type = param.type, data = param.data;
    var ref = (0,react.useState)(false), modalOpen = ref[0], changeModalOpen = ref[1];
    var ref1 = (0,react.useState)(false), errorModalOpen = ref1[0], changeErrorModalOpen = ref1[1];
    var ref2 = (0,react.useState)({}), formData = ref2[0], changeFormData = ref2[1];
    var ref3 = (0,react.useState)({}), errors = ref3[0], changeErrors = ref3[1];
    var ref4 = (0,react.useState)(false), sending = ref4[0], changeSending = ref4[1];
    var ref5 = (0,react.useState)(false), isRecaptchaRequired = ref5[0], setIsRecaptchaRequired = ref5[1];
    var ref6 = (0,react.useState)(null), error = ref6[0], setError = ref6[1];
    var ref7 = (0,react.useState)(null), captchaResponse = ref7[0], setCaptchaResponse = ref7[1];
    var recaptchaRef = (0,react.useRef)(null);
    var onCaptchaChange = function(captchaResponse) {
        setCaptchaResponse(captchaResponse);
    };
    var checkIfCaptchaIsRequired = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var ref, next_submit_requires_captcha;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return userApi/* userApi.isDataFormTemplateCaptchaNeeded */.B.isDataFormTemplateCaptchaNeeded(type);
                    case 3:
                        ref = _ctx.sent;
                        next_submit_requires_captcha = ref.data.next_submit_requires_captcha;
                        if (next_submit_requires_captcha) {
                            setIsRecaptchaRequired(true);
                        }
                        _ctx.next = 11;
                        break;
                    case 8:
                        _ctx.prev = 8;
                        _ctx.t0 = _ctx["catch"](0);
                        console.error(_ctx.t0);
                    case 11:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    8
                ]
            ]);
        }));
        return function checkIfCaptchaIsRequired() {
            return _ref.apply(this, arguments);
        };
    }();
    var changeData = function(e, data) {
        var newFormData = (0,_object_spread/* default */.Z)({}, formData);
        newFormData[data.id] = e;
        changeFormData(newFormData);
    };
    var preparedData = function() {
        var preparedData = {
            body: "".concat(type[0].toUpperCase()).concat(type.slice(1), " Report")
        };
        data.fields.forEach(function(field) {
            preparedData[field.id] = formData[field.id];
        });
        // ORC-1402: See ticket prior to changing
        if (formData.org_contact_ref) {
            preparedData.org_contact_ref = formData.org_contact_ref;
        }
        return preparedData;
    };
    var handleSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(e) {
            var dataToSend, ref, serialize_error;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        e.preventDefault();
                        if (!((0,form_functions/* validate */.G)({
                            type: type,
                            formData: formData,
                            data: data,
                            changeErrors: changeErrors
                        }) === true)) {
                            _ctx.next = 24;
                            break;
                        }
                        changeSending(true);
                        setError(null);
                        dataToSend = {
                            type: type,
                            formValues: preparedData(),
                            g_recaptcha_response: captchaResponse || undefined
                        };
                        (0,userTracking/* sendGaEvent */.k8)({
                            action: "Form Submission",
                            category: "Privacy Request",
                            label: "Submit - ".concat(type[0].toUpperCase()).concat(type.slice(1), " Form - /").concat(type)
                        });
                        _ctx.prev = 6;
                        ;
                        _ctx.next = 10;
                        return userApi/* userApi.sendFrontForm */.B.sendFrontForm(dataToSend);
                    case 10:
                        changeModalOpen(true);
                        changeSending(false);
                        (ref = recaptchaRef.current) === null || ref === void 0 ? void 0 : ref.reset();
                        addNewFormData();
                        setIsRecaptchaRequired(true);
                        _ctx.next = 24;
                        break;
                    case 17:
                        _ctx.prev = 17;
                        _ctx.t0 = _ctx["catch"](6);
                        _ctx.next = 21;
                        return checkIfCaptchaIsRequired();
                    case 21:
                        serialize_error = (0,serializeError/* serializeError */.X)(_ctx.t0);
                        if (serialize_error.message.includes("CAPTCHA")) {
                            setError(serialize_error);
                        } else {
                            changeErrorModalOpen(true);
                        }
                        changeSending(false);
                    case 24:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    6,
                    17
                ]
            ]);
        }));
        return function handleSubmit(e) {
            return _ref.apply(this, arguments);
        };
    }();
    var addNewFormData = function() {
        var newFormData = {};
        data.fields.forEach(function(field) {
            newFormData[field.id] = "";
            if (field.type === "checkbox") newFormData[field.id] = false;
        });
        changeFormData(newFormData);
    };
    (0,react.useEffect)(function() {
        addNewFormData();
        checkIfCaptchaIsRequired();
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: "data_template-background",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
            className: "section-layout",
            children: [
                modalOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoBox/* InfoBox */.v, {
                    closeModal: function() {
                        return changeModalOpen(false);
                    }
                }),
                errorModalOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoBox/* InfoBox */.v, {
                    closeModal: function() {
                        return changeErrorModalOpen(false);
                    },
                    type: "Error"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                    className: "data_template-main ".concat(type === "CCPA" ? "ccpa" : ""),
                    children: [
                        type === "CCPA" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                    className: "data_template-title",
                                    children: data.title
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    className: "data_template-paragraph",
                                    children: [
                                        data.header_1,
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            href: "mailto:".concat(data.link_target),
                                            children: data.link
                                        }),
                                        data.header_2
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "data_template-paragraph",
                                    children: data.paragraph_1
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "data_template-paragraph",
                                    children: data.paragraph_2
                                })
                            ]
                        }),
                        type === "DSAR" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                    className: "data_template-title",
                                    children: data.title
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "data_template-paragraph",
                                    children: data.paragraph
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                                onSubmit: handleSubmit,
                                children: [
                                    type === "CCPA" && typeof formData[data.fields[0].id] !== "undefined" && /*#__PURE__*/ (0,jsx_runtime.jsx)(CCPAForm, {
                                        data: data,
                                        formData: formData,
                                        changeData: changeData,
                                        errors: errors
                                    }),
                                    type === "DSAR" && typeof formData[data.fields[0].id] !== "undefined" && /*#__PURE__*/ (0,jsx_runtime.jsx)(DSARForm, {
                                        data: data,
                                        formData: formData,
                                        changeData: changeData,
                                        errors: errors
                                    }),
                                    isRecaptchaRequired && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "DataFormTemplate__captchaWrapper",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* default */.Z, {
                                            sitekey: appConfig/* appConfig.CAPTCHA_KEY */.eG.CAPTCHA_KEY,
                                            onChange: onCaptchaChange,
                                            ref: recaptchaRef
                                        })
                                    }),
                                    !!error && /*#__PURE__*/ (0,jsx_runtime.jsx)(framer_motion_es/* AnimatePresence */.M_, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(framer_motion_es/* motion.div */.ww.div, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                            className: "DataFormTemplate__errorMessageWrapper"
                                        }, appConfig/* animatePresenceConfig */.Rr), {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MessageBox/* MessageBox */._, {
                                                children: error.message
                                            })
                                        }))
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                        disabled: sending,
                                        children: data.form.button_text
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        })
    });
};


/***/ }),

/***/ 40782:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "v": function() { return /* binding */ InfoBox; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
;// CONCATENATED MODULE: ./src/landingPage/assets/svg/InfoBox/Attention.svg
/* harmony default export */ var Attention = ({"src":"/_next/static/media/Attention.623c0e2a.svg","height":18,"width":20});
;// CONCATENATED MODULE: ./src/landingPage/assets/svg/InfoBox/Error.svg
/* harmony default export */ var Error = ({"src":"/_next/static/media/Error.ff5ef9c7.svg","height":20,"width":20});
;// CONCATENATED MODULE: ./src/landingPage/assets/svg/InfoBox/Success.svg
/* harmony default export */ var Success = ({"src":"/_next/static/media/Success.47ce7b03.svg","height":20,"width":20});
// EXTERNAL MODULE: ./node_modules/react-icons/fi/index.mjs
var fi = __webpack_require__(2777);
// EXTERNAL MODULE: ./src/constants/linksConstants.js
var linksConstants = __webpack_require__(71571);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./src/landingPage/views/components/form/InfoBox.jsx









var getIcon = function(type) {
    switch(type){
        case "Attention":
            return Attention.src;
        case "Success":
            return Success.src;
        default:
            return Error.src;
    }
};
var getMessage = function(type) {
    switch(type){
        case "Attention":
            return "The page you tried to access does not exist. If you think this is a mistake, please contact Demyst support.";
        case "Success":
            return "Your form has been sent successfully. We'll be in touch.";
        default:
            return "There was an unexpected internal error with our server. Please contact Demyst support.";
    }
};
var getActionText = function(type) {
    switch(type){
        case "Success":
            return "Return Home";
        default:
            return "Contact Support";
    }
};
var getActionLink = function(type) {
    switch(type){
        case "Success":
            return linksConstants/* linksConstants.HOME */.s.HOME;
        default:
            return linksConstants/* linksConstants.CONTACT */.s.CONTACT;
    }
};
var InfoBox = function(param) {
    var actionLink = param.actionLink, actionText = param.actionText, _actionVisible = param.actionVisible, actionVisible = _actionVisible === void 0 ? true : _actionVisible, closeModal = param.closeModal, _fromContact = param.fromContact, fromContact = _fromContact === void 0 ? false : _fromContact, text = param.text, title = param.title, _type = param.type, type = _type === void 0 ? "Success" : _type;
    var ref = (0,react.useState)(false), componentMounted = ref[0], setComponentMounted = ref[1];
    (0,react.useEffect)(function() {
        setTimeout(function() {
            return setComponentMounted(true);
        }, 200);
    }, []);
    var closeWithFade = function() {
        setComponentMounted(false);
        setTimeout(function() {
            closeModal();
        }, 500);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: "info_box-main ".concat(componentMounted ? "" : "initiated"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "info_box-icon_box ".concat(type.toLowerCase()),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    className: "info_box-icon",
                    src: getIcon(type),
                    alt: type
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "info_box-text",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        className: "info_box-header",
                        children: title || "".concat(type, "!")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "info_box-message",
                        children: text || getMessage(type)
                    }),
                    actionVisible && !fromContact && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        onClick: closeModal,
                        className: "info_box-action",
                        href: actionLink || getActionLink(type),
                        children: actionText || getActionText(type)
                    }),
                    actionVisible && fromContact && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        onClick: closeModal,
                        className: "info_box-action",
                        href: actionLink || getActionLink(type),
                        children: actionText || getActionText(type)
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                className: "info_box-close",
                onClick: function() {
                    return closeWithFade();
                },
                title: "Close",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(fi/* FiX */.q5L, {})
            })
        ]
    });
};
InfoBox.propTypes = {
    actionLink: (prop_types_default()).string,
    actionText: (prop_types_default()).string,
    actionVisible: (prop_types_default()).bool,
    closeModal: (prop_types_default()).func,
    fromContact: (prop_types_default()).bool,
    text: (prop_types_default()).string,
    title: (prop_types_default()).string,
    type: (prop_types_default()).string
};


/***/ }),

/***/ 43454:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ MessageBox; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86010);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_icons_fi__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2777);




var Icon = function(param) {
    var type = param.type;
    switch(type){
        case "success":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_fi__WEBPACK_IMPORTED_MODULE_1__/* .FiCheckCircle */ ._rq, {});
        case "info":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_fi__WEBPACK_IMPORTED_MODULE_1__/* .FiInfo */ .H33, {});
        case "error":
        default:
            {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_fi__WEBPACK_IMPORTED_MODULE_1__/* .FiAlertTriangle */ .BJv, {});
            }
    }
};
var MessageBox = function(param) {
    var className = param.className, _type = param.type, type = _type === void 0 ? "error" : _type, _showIcon = param.showIcon, showIcon = _showIcon === void 0 ? true : _showIcon, children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("MessageBox", "MessageBox__".concat(type), className),
        children: showIcon ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Icon, {
                    type: type
                }),
                children
            ]
        }) : children
    });
};
MessageBox.propTypes = {
    children: prop_types__WEBPACK_IMPORTED_MODULE_3__.PropTypes.node,
    className: prop_types__WEBPACK_IMPORTED_MODULE_3__.PropTypes.string,
    type: prop_types__WEBPACK_IMPORTED_MODULE_3__.PropTypes.oneOf([
        "error",
        "info",
        "success"
    ])
};


/***/ }),

/***/ 58434:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ WorkInProgress; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);



var WorkInProgress = function(param) {
    var enabled = param.enabled, children = param.children, notice = param.notice;
    if (!enabled) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: children
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "demyst-wip",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                src: "/construction.svg",
                width: "100%",
                height: "250",
                className: "image"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                className: "title",
                children: "Service Temporarily Unavailable"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                children: notice
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                children: "We're working to resolve this issue as quickly as possible."
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                children: "Please bear with us."
            })
        ]
    });
};
WorkInProgress.protoTypes = {
    disabled: prop_types__WEBPACK_IMPORTED_MODULE_2__.PropTypes.boolean,
    children: prop_types__WEBPACK_IMPORTED_MODULE_2__.PropTypes.node,
    notice: prop_types__WEBPACK_IMPORTED_MODULE_2__.PropTypes.string
};


/***/ }),

/***/ 34853:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ esm; }
});

// UNUSED EXPORTS: ReCAPTCHA

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
;// CONCATENATED MODULE: ./node_modules/react-google-recaptcha/lib/esm/recaptcha.js
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }




var ReCAPTCHA =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(ReCAPTCHA, _React$Component);

  function ReCAPTCHA() {
    var _this;

    _this = _React$Component.call(this) || this;
    _this.handleExpired = _this.handleExpired.bind(_assertThisInitialized(_this));
    _this.handleErrored = _this.handleErrored.bind(_assertThisInitialized(_this));
    _this.handleChange = _this.handleChange.bind(_assertThisInitialized(_this));
    _this.handleRecaptchaRef = _this.handleRecaptchaRef.bind(_assertThisInitialized(_this));
    return _this;
  }

  var _proto = ReCAPTCHA.prototype;

  _proto.getValue = function getValue() {
    if (this.props.grecaptcha && this._widgetId !== undefined) {
      return this.props.grecaptcha.getResponse(this._widgetId);
    }

    return null;
  };

  _proto.getWidgetId = function getWidgetId() {
    if (this.props.grecaptcha && this._widgetId !== undefined) {
      return this._widgetId;
    }

    return null;
  };

  _proto.execute = function execute() {
    var grecaptcha = this.props.grecaptcha;

    if (grecaptcha && this._widgetId !== undefined) {
      return grecaptcha.execute(this._widgetId);
    } else {
      this._executeRequested = true;
    }
  };

  _proto.executeAsync = function executeAsync() {
    var _this2 = this;

    return new Promise(function (resolve, reject) {
      _this2.executionResolve = resolve;
      _this2.executionReject = reject;

      _this2.execute();
    });
  };

  _proto.reset = function reset() {
    if (this.props.grecaptcha && this._widgetId !== undefined) {
      this.props.grecaptcha.reset(this._widgetId);
    }
  };

  _proto.handleExpired = function handleExpired() {
    if (this.props.onExpired) {
      this.props.onExpired();
    } else {
      this.handleChange(null);
    }
  };

  _proto.handleErrored = function handleErrored() {
    if (this.props.onErrored) {
      this.props.onErrored();
    }

    if (this.executionReject) {
      this.executionReject();
      delete this.executionResolve;
      delete this.executionReject;
    }
  };

  _proto.handleChange = function handleChange(token) {
    if (this.props.onChange) {
      this.props.onChange(token);
    }

    if (this.executionResolve) {
      this.executionResolve(token);
      delete this.executionReject;
      delete this.executionResolve;
    }
  };

  _proto.explicitRender = function explicitRender() {
    if (this.props.grecaptcha && this.props.grecaptcha.render && this._widgetId === undefined) {
      var wrapper = document.createElement("div");
      this._widgetId = this.props.grecaptcha.render(wrapper, {
        sitekey: this.props.sitekey,
        callback: this.handleChange,
        theme: this.props.theme,
        type: this.props.type,
        tabindex: this.props.tabindex,
        "expired-callback": this.handleExpired,
        "error-callback": this.handleErrored,
        size: this.props.size,
        stoken: this.props.stoken,
        hl: this.props.hl,
        badge: this.props.badge
      });
      this.captcha.appendChild(wrapper);
    }

    if (this._executeRequested && this.props.grecaptcha && this._widgetId !== undefined) {
      this._executeRequested = false;
      this.execute();
    }
  };

  _proto.componentDidMount = function componentDidMount() {
    this.explicitRender();
  };

  _proto.componentDidUpdate = function componentDidUpdate() {
    this.explicitRender();
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this._widgetId !== undefined) {
      this.delayOfCaptchaIframeRemoving();
      this.reset();
    }
  };

  _proto.delayOfCaptchaIframeRemoving = function delayOfCaptchaIframeRemoving() {
    var temporaryNode = document.createElement("div");
    document.body.appendChild(temporaryNode);
    temporaryNode.style.display = "none"; // move of the recaptcha to a temporary node

    while (this.captcha.firstChild) {
      temporaryNode.appendChild(this.captcha.firstChild);
    } // delete the temporary node after reset will be done


    setTimeout(function () {
      document.body.removeChild(temporaryNode);
    }, 5000);
  };

  _proto.handleRecaptchaRef = function handleRecaptchaRef(elem) {
    this.captcha = elem;
  };

  _proto.render = function render() {
    // consume properties owned by the reCATPCHA, pass the rest to the div so the user can style it.

    /* eslint-disable no-unused-vars */
    var _this$props = this.props,
        sitekey = _this$props.sitekey,
        onChange = _this$props.onChange,
        theme = _this$props.theme,
        type = _this$props.type,
        tabindex = _this$props.tabindex,
        onExpired = _this$props.onExpired,
        onErrored = _this$props.onErrored,
        size = _this$props.size,
        stoken = _this$props.stoken,
        grecaptcha = _this$props.grecaptcha,
        badge = _this$props.badge,
        hl = _this$props.hl,
        childProps = _objectWithoutPropertiesLoose(_this$props, ["sitekey", "onChange", "theme", "type", "tabindex", "onExpired", "onErrored", "size", "stoken", "grecaptcha", "badge", "hl"]);
    /* eslint-enable no-unused-vars */


    return react.createElement("div", _extends({}, childProps, {
      ref: this.handleRecaptchaRef
    }));
  };

  return ReCAPTCHA;
}(react.Component);


ReCAPTCHA.displayName = "ReCAPTCHA";
ReCAPTCHA.propTypes = {
  sitekey: (prop_types_default()).string.isRequired,
  onChange: (prop_types_default()).func,
  grecaptcha: (prop_types_default()).object,
  theme: prop_types_default().oneOf(["dark", "light"]),
  type: prop_types_default().oneOf(["image", "audio"]),
  tabindex: (prop_types_default()).number,
  onExpired: (prop_types_default()).func,
  onErrored: (prop_types_default()).func,
  size: prop_types_default().oneOf(["compact", "normal", "invisible"]),
  stoken: (prop_types_default()).string,
  hl: (prop_types_default()).string,
  badge: prop_types_default().oneOf(["bottomright", "bottomleft", "inline"])
};
ReCAPTCHA.defaultProps = {
  onChange: function onChange() {},
  theme: "light",
  type: "image",
  tabindex: 0,
  size: "normal",
  badge: "bottomright"
};
// EXTERNAL MODULE: ./node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js
var hoist_non_react_statics_cjs = __webpack_require__(8679);
var hoist_non_react_statics_cjs_default = /*#__PURE__*/__webpack_require__.n(hoist_non_react_statics_cjs);
;// CONCATENATED MODULE: ./node_modules/react-async-script/lib/esm/async-script-loader.js
function async_script_loader_extends() { async_script_loader_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return async_script_loader_extends.apply(this, arguments); }

function async_script_loader_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function async_script_loader_inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }




var SCRIPT_MAP = {}; // A counter used to generate a unique id for each component that uses the function

var idCount = 0;
function makeAsyncScript(getScriptURL, options) {
  options = options || {};
  return function wrapWithAsyncScript(WrappedComponent) {
    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || "Component";

    var AsyncScriptLoader =
    /*#__PURE__*/
    function (_Component) {
      async_script_loader_inheritsLoose(AsyncScriptLoader, _Component);

      function AsyncScriptLoader(props, context) {
        var _this;

        _this = _Component.call(this, props, context) || this;
        _this.state = {};
        _this.__scriptURL = "";
        return _this;
      }

      var _proto = AsyncScriptLoader.prototype;

      _proto.asyncScriptLoaderGetScriptLoaderID = function asyncScriptLoaderGetScriptLoaderID() {
        if (!this.__scriptLoaderID) {
          this.__scriptLoaderID = "async-script-loader-" + idCount++;
        }

        return this.__scriptLoaderID;
      };

      _proto.setupScriptURL = function setupScriptURL() {
        this.__scriptURL = typeof getScriptURL === "function" ? getScriptURL() : getScriptURL;
        return this.__scriptURL;
      };

      _proto.asyncScriptLoaderHandleLoad = function asyncScriptLoaderHandleLoad(state) {
        var _this2 = this;

        // use reacts setState callback to fire props.asyncScriptOnLoad with new state/entry
        this.setState(state, function () {
          return _this2.props.asyncScriptOnLoad && _this2.props.asyncScriptOnLoad(_this2.state);
        });
      };

      _proto.asyncScriptLoaderTriggerOnScriptLoaded = function asyncScriptLoaderTriggerOnScriptLoaded() {
        var mapEntry = SCRIPT_MAP[this.__scriptURL];

        if (!mapEntry || !mapEntry.loaded) {
          throw new Error("Script is not loaded.");
        }

        for (var obsKey in mapEntry.observers) {
          mapEntry.observers[obsKey](mapEntry);
        }

        delete window[options.callbackName];
      };

      _proto.componentDidMount = function componentDidMount() {
        var _this3 = this;

        var scriptURL = this.setupScriptURL();
        var key = this.asyncScriptLoaderGetScriptLoaderID();
        var _options = options,
            globalName = _options.globalName,
            callbackName = _options.callbackName,
            scriptId = _options.scriptId; // check if global object already attached to window

        if (globalName && typeof window[globalName] !== "undefined") {
          SCRIPT_MAP[scriptURL] = {
            loaded: true,
            observers: {}
          };
        } // check if script loading already


        if (SCRIPT_MAP[scriptURL]) {
          var entry = SCRIPT_MAP[scriptURL]; // if loaded or errored then "finish"

          if (entry && (entry.loaded || entry.errored)) {
            this.asyncScriptLoaderHandleLoad(entry);
            return;
          } // if still loading then callback to observer queue


          entry.observers[key] = function (entry) {
            return _this3.asyncScriptLoaderHandleLoad(entry);
          };

          return;
        }
        /*
         * hasn't started loading
         * start the "magic"
         * setup script to load and observers
         */


        var observers = {};

        observers[key] = function (entry) {
          return _this3.asyncScriptLoaderHandleLoad(entry);
        };

        SCRIPT_MAP[scriptURL] = {
          loaded: false,
          observers: observers
        };
        var script = document.createElement("script");
        script.src = scriptURL;
        script.async = true;

        for (var attribute in options.attributes) {
          script.setAttribute(attribute, options.attributes[attribute]);
        }

        if (scriptId) {
          script.id = scriptId;
        }

        var callObserverFuncAndRemoveObserver = function callObserverFuncAndRemoveObserver(func) {
          if (SCRIPT_MAP[scriptURL]) {
            var mapEntry = SCRIPT_MAP[scriptURL];
            var observersMap = mapEntry.observers;

            for (var obsKey in observersMap) {
              if (func(observersMap[obsKey])) {
                delete observersMap[obsKey];
              }
            }
          }
        };

        if (callbackName && typeof window !== "undefined") {
          window[callbackName] = function () {
            return _this3.asyncScriptLoaderTriggerOnScriptLoaded();
          };
        }

        script.onload = function () {
          var mapEntry = SCRIPT_MAP[scriptURL];

          if (mapEntry) {
            mapEntry.loaded = true;
            callObserverFuncAndRemoveObserver(function (observer) {
              if (callbackName) {
                return false;
              }

              observer(mapEntry);
              return true;
            });
          }
        };

        script.onerror = function () {
          var mapEntry = SCRIPT_MAP[scriptURL];

          if (mapEntry) {
            mapEntry.errored = true;
            callObserverFuncAndRemoveObserver(function (observer) {
              observer(mapEntry);
              return true;
            });
          }
        };

        document.body.appendChild(script);
      };

      _proto.componentWillUnmount = function componentWillUnmount() {
        // Remove tag script
        var scriptURL = this.__scriptURL;

        if (options.removeOnUnmount === true) {
          var allScripts = document.getElementsByTagName("script");

          for (var i = 0; i < allScripts.length; i += 1) {
            if (allScripts[i].src.indexOf(scriptURL) > -1) {
              if (allScripts[i].parentNode) {
                allScripts[i].parentNode.removeChild(allScripts[i]);
              }
            }
          }
        } // Clean the observer entry


        var mapEntry = SCRIPT_MAP[scriptURL];

        if (mapEntry) {
          delete mapEntry.observers[this.asyncScriptLoaderGetScriptLoaderID()];

          if (options.removeOnUnmount === true) {
            delete SCRIPT_MAP[scriptURL];
          }
        }
      };

      _proto.render = function render() {
        var globalName = options.globalName; // remove asyncScriptOnLoad from childProps

        var _this$props = this.props,
            asyncScriptOnLoad = _this$props.asyncScriptOnLoad,
            forwardedRef = _this$props.forwardedRef,
            childProps = async_script_loader_objectWithoutPropertiesLoose(_this$props, ["asyncScriptOnLoad", "forwardedRef"]); // eslint-disable-line no-unused-vars


        if (globalName && typeof window !== "undefined") {
          childProps[globalName] = typeof window[globalName] !== "undefined" ? window[globalName] : undefined;
        }

        childProps.ref = forwardedRef;
        return (0,react.createElement)(WrappedComponent, childProps);
      };

      return AsyncScriptLoader;
    }(react.Component); // Note the second param "ref" provided by React.forwardRef.
    // We can pass it along to AsyncScriptLoader as a regular prop, e.g. "forwardedRef"
    // And it can then be attached to the Component.


    var ForwardedComponent = (0,react.forwardRef)(function (props, ref) {
      return (0,react.createElement)(AsyncScriptLoader, async_script_loader_extends({}, props, {
        forwardedRef: ref
      }));
    });
    ForwardedComponent.displayName = "AsyncScriptLoader(" + wrappedComponentName + ")";
    ForwardedComponent.propTypes = {
      asyncScriptOnLoad: (prop_types_default()).func
    };
    return hoist_non_react_statics_cjs_default()(ForwardedComponent, WrappedComponent);
  };
}
;// CONCATENATED MODULE: ./node_modules/react-google-recaptcha/lib/esm/recaptcha-wrapper.js


var callbackName = "onloadcallback";
var globalName = "grecaptcha";

function getOptions() {
  return typeof window !== "undefined" && window.recaptchaOptions || {};
}

function getURL() {
  var dynamicOptions = getOptions();
  var hostname = dynamicOptions.useRecaptchaNet ? "recaptcha.net" : "www.google.com";
  return "https://" + hostname + "/recaptcha/api.js?onload=" + callbackName + "&render=explicit";
}

/* harmony default export */ var recaptcha_wrapper = (makeAsyncScript(getURL, {
  callbackName: callbackName,
  globalName: globalName
})(ReCAPTCHA));
;// CONCATENATED MODULE: ./node_modules/react-google-recaptcha/lib/esm/index.js


/* harmony default export */ var esm = (recaptcha_wrapper);


/***/ })

}]);